// extracted by mini-css-extract-plugin
export var dropdownButton = "_3d-0";
export var fullWidthDropdownButton = "_3d-1";
export var icon = "_3d-3";
export var iconPlaceholder = "_3d-2";
export var menuItemRow = "_3d-8";
export var separator = "_3d-c";
export var shortcutContainer = "_3d-7";
export var shortcutIconLg = "_3d-6";
export var shortcutIconMd = "_3d-5";
export var shortcutIconSm = "_3d-4";
export var submenuChevron = "_3d-b";
export var submenuDropdown = "_3d-9";
export var submenuTriggerRow = "_3d-a";